.ab{aspect-ratio:1/1;}